import React from 'react';
import { Button, ButtonToolbar } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import renderRadioButtonField from '../../../../shared/components/form/RadioButton';

const WizardFormTwo = ({ handleSubmit, previousPage }) => (
  <form className="form form--vertical wizard__form" onSubmit={handleSubmit}>
    <div className="form__form-group">
      <h4 className="wizard__description">
        1. Vous avez défini une ou des zones géographiques. Êtes-vous ouvert à ce qu'on les élargissent de façon 
        pertinente si nous pensons qu'il y a de belles opportunités ?
      </h4>
      <div className="form__form-group-field radio-double-height">
        <Field
          name="location"
          component={renderRadioButtonField}
          label="oui"
          className="button"
          radioValue="1"
        />
        <Field
          name="location"
          component={renderRadioButtonField}
          label="oui mais avec mon accord préalable"
          className="button"
          radioValue="2"
        />
        <Field
          name="location"
          component={renderRadioButtonField}
          label="Non"
          className="button"
          radioValue="0"
        />
      </div>
    </div>

    <div className="form__form-group">
      <h4 className="wizard__description">
        2. Si nous rencontrons des difficultés à trouver tous les commerces désirés pour votre campagne, 
        nous autorisez-vous à vous contacter pour vous proposer des solutions ?
      </h4>
      <div className="form__form-group-field radio-double-height">
        <Field
          name="solutions"
          component={renderRadioButtonField}
          label="oui"
          className="button"
          radioValue="1"
        />
        <Field
          name="solutions"
          component={renderRadioButtonField}
          label="Non"
          className="button"
          radioValue="0"
        />
      </div>
    </div>
    <ButtonToolbar className="form__button-toolbar wizard__toolbar">
      <Button color="primary" type="button" className="previous" onClick={previousPage}>Précédent</Button>
      <Button color="primary" type="submit" className="next">Suivant</Button>
    </ButtonToolbar>
  </form>
);

WizardFormTwo.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'wizard', //                 <------ same form name
  destroyOnUnmount: false, //        <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(WizardFormTwo);
